import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ children, user }) => {
  const location = useLocation();

  if (!localStorage.getItem("token") || !user.name) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};

export default RequireAuth;
